import React, { useState } from 'react';
import supabase from '../supabase/supabase';

export default function CrmLogin() {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    const form = new FormData(event.currentTarget);
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: form.get('email'),
      password: form.get('password')
    });
    if (signInError) setError(signInError.message);
    setBusy(false);
  }

  return (
    <div className="crm-auth">
      <div className="crm-auth-card">
        <span className="crm-kicker">OTTERWORKS ENGINEERING</span>
        <h1>Welcome back.</h1>
        <p>Sign in with your authorized staff account to manage customers.</p>
        <form onSubmit={handleSubmit}>
          <label>Email address<input type="email" name="email" autoComplete="username" required placeholder="you@company.com" /></label>
          <label>Password<input type="password" name="password" autoComplete="current-password" required placeholder="Enter password" /></label>
          {error && <p className="crm-error" role="alert">{error}</p>}
          <button type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        </form>
        <a href="/">← Back to website</a>
      </div>
    </div>
  );
}